var _defs, _rect, _path, _path2, _circle, _path3, _path4, _path5, _ellipse, _ellipse2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdeaPanel3A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 227 457",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3,.cls-4{fill:none;}.cls-2,.cls-5,.cls-6,.cls-7{fill:#fff;}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7{stroke:#000;}.cls-2,.cls-3,.cls-4{stroke-miterlimit:10;}.cls-4,.cls-5,.cls-6,.cls-7{stroke-linecap:round;}.cls-5,.cls-6,.cls-7{stroke-linejoin:round;}.cls-6{stroke-width:0.81px;}.cls-7{stroke-width:0.81px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 227,
    height: 457
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M119.28,268.4a15.47,15.47,0,0,0,4.88,3.48,7.14,7.14,0,0,0,5.85,0c3.43-1.77,4-6.53,3-10.25s-3.2-7.09-3.82-10.89"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.5,255.71a31.91,31.91,0,0,0-.71,9.72c.43,3.24,2,6.49,4.84,8.11s7,1.1,8.7-1.66"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 95.93,
    cy: 243.51,
    r: 33.49
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.21,252.9a52.89,52.89,0,0,0,30-43.3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M83.81,236.4a44,44,0,0,0,45.69,3.53"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M124.71,242.6c0,6.53.14,10.23.65,16.54"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.04,
    cy: 257.33,
    rx: 2.89,
    ry: 4.04,
    transform: "translate(-2.75 0.96) rotate(-0.61)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.26,
    cy: 257.11,
    rx: 2.89,
    ry: 4.04,
    transform: "translate(-2.75 1.17) rotate(-0.61)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M94.87,269.43a8.94,8.94,0,0,0,6.38.26"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.85,359.6l-1.38,23.85a8.61,8.61,0,0,0,10.07,9l119.87-20.89a8.61,8.61,0,0,0,4.87-14.3l-15.54-17a8.57,8.57,0,0,0-6.93-2.79A744.68,744.68,0,0,0,63.62,351.68,8.59,8.59,0,0,0,56.85,359.6Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M71.59,298.25a12.72,12.72,0,0,0-8.41,3.92,1.11,1.11,0,0,0-.41.9c.09.46.61.63,1,.71a56.16,56.16,0,0,0,10.45,1.31,18.71,18.71,0,0,0,10-2.58C80.58,299,75.37,298,71.59,298.25Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M66.24,302.31c-2.46,19.47-4.92,39.28-1.68,58.64a20.37,20.37,0,0,0,2.14,7,8,8,0,0,0,5.74,4.16c3.29.36,6.37-2.11,7.75-5.12a17.56,17.56,0,0,0,1.36-7l3,2.06a5.81,5.81,0,0,0,1.72.91,2,2,0,0,0,1.84-.37,1.94,1.94,0,0,0,.43-1.83,5.23,5.23,0,0,0-.91-1.73,33.46,33.46,0,0,0-6.3-6.61c-.76-17.07-3.21-34.2-.66-51.07"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M141.16,291.29a38.56,38.56,0,0,0-9.28,2.16,13.07,13.07,0,0,0-7,6.17,44.63,44.63,0,0,0,14.32-4.86,6.24,6.24,0,0,0,1.8-1.29,2.42,2.42,0,0,0,.65-2.05C141.33,291.44,141,291.46,141.16,291.29Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.74,298.07c7.25,12.79,14.58,25.77,18.29,40,.15.57.29,1.13.43,1.7a16,16,0,0,0-4.78,6.05,5.45,5.45,0,0,0-.53,1.89,2.28,2.28,0,0,0,.66,1.8,2.46,2.46,0,0,0,2.85.09,8.48,8.48,0,0,0,2.17-2.14c.43-.52.88-1,1.35-1.5.22.66.45,1.31.73,1.94a14.92,14.92,0,0,0,6.51,7.66c3,1.56,7.09,1.43,9.57-.92,2.82-2.68,2.85-7.15,2.15-11-1.74-9.6-6.67-18.31-12-26.48s-11.21-16.06-15.21-25"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M83.14,373.89l3.49,5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M86.38,367.48l5.14,3.18"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M77.26,375.87c.06,2.54.08,3.5.15,6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M151.52,360.94l-4,4.63"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M158.53,362.45c-.74,2.43-1,3.35-1.77,5.77"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M148.12,355.74l-5.81,1.67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaPanel3A);
export default __webpack_public_path__ + "static/media/Idea_Panel_3a.ee4f48f3a09e5d5d929722dacdb02f12.svg";
export { ForwardRef as ReactComponent };